import React from "react";
import NZAssociatedTransactions from "./Common/NZAssociatedTransactions";
// import "./AssociatedTransactions.css";
const NZAssociatedTransactionsHandler = ({ associatedTransactions }) => {
  /** add a validation if the associated transaction table will become tenant specific */
  return <NZAssociatedTransactions associatedTransactions={associatedTransactions}></NZAssociatedTransactions>;
};

export default NZAssociatedTransactionsHandler;
